const contactDetails = [
  {
    icon: 'ri-mail-line',
    label: 'Email',
    value: 'contact@forecapitalgrp.com',
    href: 'mailto:contact@forecapitalgrp.com',
  },
  {
    icon: 'ri-map-pin-line',
    label: 'Office',
    value: 'Austin, TX',
    href: '#',
  },
];

const hours = [
  { day: 'Monday – Friday', time: '9:00 AM – 6:00 PM CST' },
];

export default function ContactInfo() {
  return (
    <div className="flex flex-col gap-12">
      {/* Contact Details */}
      <div>
        <p
          className="text-[#a8894a] text-[10px] uppercase tracking-[0.25em] font-medium mb-5"
          style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
        >
          Contact Details
        </p>
        <div className="flex flex-col gap-6">
          {contactDetails.map((item) => (
            <div key={item.label} className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#122852] shrink-0">
                <i className={`${item.icon} text-[#d3b366] text-lg`} />
              </div>
              <div>
                <p
                  className="text-[#1A1A1A]/40 text-[10px] uppercase tracking-[0.15em] font-medium mb-1"
                  style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
                >
                  {item.label}
                </p>
                <a
                  href={item.href}
                  className="text-[#061e45] text-[15px] font-medium hover:text-[#a8894a] transition-colors duration-200 cursor-pointer whitespace-pre-line"
                  style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
                >
                  {item.value}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Business Hours */}
      <div>
        <p
          className="text-[#a8894a] text-[10px] uppercase tracking-[0.25em] font-medium mb-5"
          style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
        >
          Business Hours
        </p>
        <div className="flex flex-col gap-3">
          {hours.map((h) => (
            <div key={h.day} className="flex items-center justify-between">
              <span
                className="text-[#1A1A1A]/60 text-[15px]"
                style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
              >
                {h.day}
              </span>
              <span
                className="text-[#061e45] text-[15px] font-medium"
                style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
              >
                {h.time}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Response Promise */}
      <div className="p-8" style={{ background: 'linear-gradient(135deg, #1a3870 0%, #061e45 100%)' }}>
        <div className="flex items-center gap-3 mb-4">
          <i className="ri-time-line text-[#d3b366] text-xl" />
          <p
            className="text-[#d3b366] text-[10px] uppercase tracking-[0.2em] font-medium"
            style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
          >
            Response Time
          </p>
        </div>
        <p
          className="text-white text-lg font-light leading-snug mb-3"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          We reply within 24 hours.
        </p>
        <p
          className="text-white/50 text-[15px] leading-relaxed"
          style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
        >
          Our support team is available around the clock for existing clients.
        </p>
      </div>
    </div>
  );
}